// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2-tax","head":"ProcedureTableInfo_head__3Ikdl"};